(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dynamic-fit-guide"] && !Shopify.designMode) return;
  try {
    (function() {
    var triggers = document.querySelectorAll('[aria-haspopup="dialog"][aria-controls^="fit-guide-drawer-"]');

    triggers.forEach(function(trigger) {
      var drawerId = trigger.getAttribute('aria-controls');
      var drawer = document.getElementById(drawerId);
      var backdrop = document.querySelector('[data-fit-guide-backdrop="' + drawerId + '"]');
      var closeBtn = drawer ? drawer.querySelector('[data-fit-guide-close]') : null;

      if (!drawer || !backdrop) return;

      var focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      var previousFocus = null;

      function openDrawer() {
        previousFocus = document.activeElement;
        drawer.hidden = false;
        backdrop.hidden = false;

        /* Allow DOM update before starting transition */
        requestAnimationFrame(function() {
          drawer.setAttribute('aria-hidden', 'false');
          backdrop.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';

          /* Move focus to close button */
          if (closeBtn) {
            closeBtn.focus();
          }
        });
      }

      function closeDrawer() {
        drawer.setAttribute('aria-hidden', 'true');
        backdrop.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        /* Wait for transition to finish before hiding */
        drawer.addEventListener('transitionend', function handler() {
          drawer.hidden = true;
          backdrop.hidden = true;
          drawer.removeEventListener('transitionend', handler);

          if (previousFocus) {
            previousFocus.focus();
          }
        }, { once: true });
      }

      /* Focus trap */
      function trapFocus(e) {
        if (drawer.hidden) return;
        var focusable = drawer.querySelectorAll(focusableSelector);
        if (focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      trigger.addEventListener('click', openDrawer);

      if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer);
      }

      backdrop.addEventListener('click', closeDrawer);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !drawer.hidden) {
          closeDrawer();
        }
        if (e.key === 'Tab' && !drawer.hidden) {
          trapFocus(e);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
